<template>
  <el-container>
    <el-header style="height: 45px;">
      <div class="container-header"><AppHeader /></div>
    </el-header>
    <div style="height: 1px; background-color: rgb(220, 220, 220)"></div>
    <el-main  style="height: calc(100vh - 80px);"><router-view></router-view></el-main>
  </el-container>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";

export default {
  name: "App",
  components: {
    AppHeader,
  },
  mounted() {
    this.$router.push("index");
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
:root {
  --screen-max-width: 1376px;
}
.container-header {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: var(--screen-max-width);
  min-width: 650px;
}
</style>
